import { useMemo } from 'react';

import AnalyticsResponseRollupCollection from 'components/insights/query/AnalyticsResponseRollupCollection';
import DataTable from 'components/shared/DataTable';
import { useNetworkPerformanceStore } from 'stores/networkPerformanceStore';

import { buildProviderPerformanceColumns, buildProviderPerformanceRows } from './providerPerformanceColumns';

type Props = {
  loading: boolean;
  rollups: AnalyticsResponseRollupCollection;
};

export default function ProviderPerformanceTable({ loading, rollups }: Props) {
  const selectedGroupType = useNetworkPerformanceStore((state) => state.selectedGroupType);

  const entityHeader = `${selectedGroupType?.displayName ?? ''} Company`.trim();
  const columns = useMemo(() => buildProviderPerformanceColumns(entityHeader), [entityHeader]);
  const data = useMemo(() => buildProviderPerformanceRows(rollups), [rollups]);

  return (
    <DataTable
      columns={columns}
      data={data}
      loading={loading}
      freezeFirstColumn
      hasFooter={false}
      defaultSortBy={[{ id: 'totalDischarges', desc: true }]}
    />
  );
}
